import React from 'react';

/**
 * PageContainer Component
 * 
 * Scalable wrapper for page content that ensures consistent margins,
 * padding, and max-width across all device sizes.
 * 
 * Usage:
 * <PageContainer>
 *   <Header />
 *   <Content />
 * </PageContainer>
 */
export default function PageContainer({
    children,
    className = '',
    maxWidth = 'max-w-7xl' // default wide for standard pages
}) {
    return (
        <div className={`w-full mx-auto px-4 sm:px-6 lg:px-8 py-6 ${maxWidth} ${className}`}>
            {children}
        </div>
    );
}
